// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean, number, any, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isEngagementV2LinkTemplatesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: any,
      prepend: any,
      tag_names: arrayOf(string),
      territory_ids: arrayOf(string),
      context_property_tags: arrayOf(any),
      key_value_pairs: arrayOf(
        objectOf({
          id: string,
          key: string,
          value: string,
          custom_value: boolean,
        })
      ),
      auto_add_enabled: boolean,
      last_edited_at: anyOf(number, nullValidation),
      created_by: anyOf(string, nullValidation),
      last_edited_by: anyOf(string, nullValidation),
    })
  ),
});
